<div class="search-bar-container">
  <div class="search-bar-search">
    <ion-icon src="assets/global/img/search-bar-icon.svg" class="search-bar-icon"></ion-icon>
    <input #searchInput class="search-bar-input" [(ngModel)]="term" placeholder="Buscar juegos" />
  </div>
  <button
    *ngIf="this.globalVars.FEATURES.CAS_MoreFilters || this.globalVars.isMirror"
    class="search-bar-button filter"
    (click)="filtersClicked()"
  >
    <ion-icon src="assets/global/img/more-filters.svg" class="search-bar-icon"></ion-icon>
    <div class="button-text">{{'Filtros' | translate}}</div>
  </button>
  <button class="search-bar-button calendar" (click)="calendarClicked()">
    <ion-icon src="assets/global/img/custom-calendar.svg" class="search-bar-icon"></ion-icon>
    <div class="button-text">{{globalVars.FEATURES.casinoCalendarName}}</div>
  </button>
</div>
